let strategies = {
    required: function (val, name) {
        let result = new ValidateResult();
        if (isNullOrEmpty(val)) {
            result.success = false;
            result.message = name + "不能为空";
            return result;
        }

        return result;
    },
    minLength: function (val, len, name) {
        let result = new ValidateResult();
        if (isNullOrEmpty(val)) {
            return result;
        }

        if (val.length < len) {
            result.success = false;
            result.message = name + "长度不能小于" + len;
            return result;
        }

        return result;
    },
    maxLength: function (val, len, name) {
        let result = new ValidateResult();
        if (isNullOrEmpty(val)) {
            return result;
        }

        if (val.length > len) {
            result.success = false;
            result.message = name + "长度不能大于" + len;
            return result;
        }

        return result;
    },
    isMobile: function (val, name) {
        let result = new ValidateResult();
        if (isNullOrEmpty(val)) {
            return result;
        }

        let pattern = /^1\d{10}$/;
        if (!pattern.test(val)) {
            result.success = false;
            result.message = name + "格式不正确";
            return result;
        }

        return result;
    },
    isAge: function (val, name) {
        let result = new ValidateResult();
        if (isNullOrEmpty(val)) {
            return result;
        }

        let pattern = /^([1-9]\d*|[0]{1,1})$/;
        if (!pattern.test(val)) {
            result.success = false;
            result.message = name + "格式不正确";
            return result;
        }
        else if(val==0 || val>=18)
        {
            result.success = false;
            result.message = name + "不正确";
            return result;
        }

        return result;
    },
    password: function (val, name) {
        let result = new ValidateResult();
        if (isNullOrEmpty(val)) {
            return result;
        }
        if (!/^[\S]{6,12}$/.test(val)) {
            result.success = false;
            result.message = name + "必须6-12位字符,且不能出现空格";
            return result;
        }
        if (!/[A-Z]/.test(val)) {
            result.success = false;
            result.message = name + "必须包含大写字母";
            return result;
        }
        if (!/[a-z]/.test(val)) {
            result.success = false;
            result.message = name + "必须包含小写字母";
            return result;
        }
        if (!/[0-9]/.test(val)) {
            result.success = false;
            result.message = name + "必须包含数字";
            return result;
        }
        // if (!/[!@@#\$%\^\&*'"\/{}\[\]?,;|)\(+=._-]+/.test(val)) {
        //     result.success = false;
        //     result.message = name + "必须包含特殊字符";
        //     return result;
        // }
        return result;
    },
// 1.常规车牌号：仅允许以汉字开头，后面可录入六个字符，由大写英文字母和阿拉伯数字组成。如：粤B12345；
// 2.最后一个为汉字的车牌：允许以汉字开头，后面可录入六个字符，前五位字符，由大写英文字母和阿拉伯数字组成，而最后一个字符为汉字，汉字包括“挂”、“学”、“警”、“港”、“澳”。如：粤Z1234港。
// 3.新军车牌：以两位为大写英文字母开头，后面以5位阿拉伯数字组成。如：BA12345。
    isPlateNumber: function (val, name) {
        val = val.toUpperCase();
        let result = new ValidateResult();
        if (isNullOrEmpty(val)) {
            return result;
        }
        if (val.length > 8) {
            result.success = false;
            result.message = name + "车牌号过长：" + val;
            return result;
        }

        var startVal = val.substr(0, 7);
        var lastVal = '';
        if (val.length > 7) {
            lastVal = val.substr(7, 1);
        }
        let pattern1 = /[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使A-Z]{1}[A-Z0-9]{5}[A-Z0-9领挂学警港澳]{1}$/;
        let pattern2 = /[A-Z0-9领挂学警港澳]{1}$/;


        if (lastVal) {
            if (!pattern2.test(lastVal)) {
                result.success = false;
                result.message = name + "格式不正确：" + val;
                return result;
            }
        }

        if (!pattern1.test(startVal)) {
            result.success = false;
            result.message = name + "格式不正确：" + val;
            return result;
        }


        return result;
    },
    isIdCard: function (val, name) {
        let result = new ValidateResult();
        if (isNullOrEmpty(val)) {
            return result;
        }

        let failResult = {
            success: false,
            message: name + "格式不正确"
        };
        if (val.length != 15 && val.length != 18) {
            return failResult;
        }

        let pattern = val.length === 15 ?
            /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$/ :
            /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        if (!pattern.test(val)) {
            return failResult;
        }

        if (val.length === 18) {
            let weightingFactor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            let total = 0;
            for (let i = 0; i < weightingFactor.length; i++) {
                total += weightingFactor[i] * val[i];
            }
            let code = "10X98765432";
            if (code[total % 11] != val[val.length - 1].toUpperCase()) {
                return failResult;
            }
        }

        return result;
    }
};

function isNullOrEmpty(val) {
    if (val === undefined || val === null || val === '') {
        return true;
    }

    return false;
}

function ValidateResult() {
    this.success = true;
    this.message = "";
}

/* 接受验证的数组
    [{
        value: "test",
        name: "关键词",
        rules: [{
            rule: 'required',
            msg: '关键词不能为空'
        }]
    }] */

let validate = function (arr) {
    let result = new ValidateResult();
    for (let i = 0, l1 = arr.length; i < l1; i++) {
        let item = arr[i];
        let stop = false;
        for (let k = 0, l2 = item.rules.length; k < l2; k++) {

            let r = item.rules[k];
            let arg = r.rule.split(':');
            let rule = arg.shift();
            if (r.type) {
                arg.unshift(r.type);
            }
            arg.unshift(item.value);
            arg.push(item.name);
            let status = strategies[rule].apply(null, arg);
            if (!status.success) {
                result = status;
                if (r.msg) {
                    result.message = r.msg;
                }
                stop = true;
                break;
            }
        }
        if (stop) break;
    }
    return result;
};

export default validate;